import React from "react";
import "./index.css";
import Header from "../../components/chi/layout/header";
import Footer from "../../components/chi/layout/footer";
import CardSlide from "../../components/chi/Slider/card_slide";
import ShopByCat from "../../components/chi/home/shopbycat";
import HeroSection from "../../components/chi/home/hero";
import Prevent from "../../components/chi/home/prevent";
import JoinDay from "../../components/chi/home/joinday";
import Elevate from "../../components/chi/home/elevate";
import Ingredient from "../../components/chi/home/ingredient";
import BestSellerAndNewarrivel from "../../components/chi/home/bestsellerandnewarrivel";
import Loved from "../../components/chi/home/loved";
import FeateureBrad from "../../components/chi/home/feateurebrad";
import Place from "../../components/chi/home/place";
import CategorySlide from "../../components/chi/Slider/categories_slide";
import img1 from "../../assets/images/chi/img1.jpeg";
import img2 from "../../assets/images/chi/img3-removebg-preview.png";
import img3 from "../../assets/images/chi/img3.jpg";
import img4 from "../../assets/images/chi/img4.jpg";
import img5 from "../../assets/images/chi/img5.jpg";
import img6 from "../../assets/images/chi/shampoo.png";
import logo from "../../assets/images/chi/banner2.jpg";

const HomePage = () => {
  const CardSlideData = [
    {
      id: 1,
      price: "$182.00",
      cate: "SkinCeuticals C E Ferulic (1 fl. oz.)",
      img: "https://static.thcdn.com/images/small/webp//productimg/original/11289609-1995037121294344.jpg",
      label: "Wicked Lady",
    },
    {
      id: 2,
      price: "230000 MMK",
      cate: "Jack And Gina Zinfandel Rose Wine 75cl",
      img: "https://static.thcdn.com/images/small/webp//productimg/original/11582506-6064978637869764.jpg",
      label: "Jack And Gina",
    },
    {
      id: 3,
      price: "260000 MMK",
      cate: "Selladore En Provence Rose Wine 2022 75cl",
      img: "https://static.thcdn.com/images/small/webp//productimg/original/13547804-3064932747510939.jpg",
      label: "William Chase",
    },
    {
      id: 4,
      price: "300000 MMK",
      cate: "Chateau d'Esclans Whispering Angel Rose Wine 2022 75cl",
      img: "  https://static.thcdn.com/images/small/webp//productimg/original/14018243-9275043599035689.jpg",
      label: "Chateau d'Esclans",
    },
    {
      id: 5,
      price: "something",
      cate: "recom",
      img: "https://static.thcdn.com/images/small/webp//productimg/original/11290635-2054892767941057.jpg",
    },
  ];
  const ElevateData = [
    {
      id: 1,
      img: "https://static.thcdn.com/images/small/webp/widgets/208-us/09/original-Dermstore_Anniversary_Sale_Trade_Trending_-_Untitled_Page_%283%29-121809.png",
      title: "SkinMedica",
    },
    {
      id: 2,
      img: "https://static.thcdn.com/images/small/webp/widgets/208-us/05/original-Dermstore_Anniversary_Sale_Trade_Trending_-_Untitled_Page_%284%29-122005.png",
      title: "Obagi",
    },

    {
      id: 3,
      img: "https://static.thcdn.com/images/small/webp/widgets/208-us/53/original-Dermstore_Anniversary_Sale_Trade_Trending_-_Untitled_Page_%285%29-122353.png",
      title: "SkinMedica",
    },

    {
      id: 4,
      img: "https://static.thcdn.com/images/small/webp/widgets/208-us/09/original-Dermstore_Anniversary_Sale_Trade_Trending_-_Untitled_Page_%283%29-121809.png",
      title: "Eminence Organic Skin Care",
    },

    {
      id: 5,
      img: "https://static.thcdn.com/images/small/webp/widgets/208-us/47/original-Dermstore_Anniversary_Sale_Trade_Trending_-_Untitled_Page_%286%29-123047.png",
      title: "iS Clinical",
    },

    {
      id: 6,
      img: "https://static.thcdn.com/images/small/webp/widgets/208-us/20/original-Dermstore_Anniversary_Sale_Trade_Trending_-_Untitled_Page_%287%29-123120.png",
      title: "Revision Skincare",
    },
  ];
  const aboutData = [
    {
      id: 1,
      title: "About",
      img: logo,
      // title_span: "start Here",
      // desc: "The newest luxury wellness spa experience in Yangon for your inner peace and outer beauty.",
      // img: banner1,
    },
    {
      id: 2,
      title: "Services",
      img: logo,

      // title_span: "start Here",
      // desc: "The newest luxury wellness spa experience in Yangon for your inner peace and outer beauty.",
      // img: banner2,
    },
    {
      id: 3,
      title: "Facilities",
      img: logo,
      // title_span: "start Here",
      // desc: "The newest luxury wellness spa experience in Yangon for your inner peace and outer beauty.",
      // img: banner2,
    },
    {
      id: 4,
      title: "Services",
      img: logo,
      // title_span: "start Here",
      // desc: "The newest luxury wellness spa experience in Yangon for your inner peace and outer beauty.",
      // img: banner2,
    },
    {
      id: 5,
      title: "Location",
      img: logo,
      link: "https://maps.app.goo.gl/8ZKEL2vjZtGaS3X5A?g_st=ic",
      // title_span: "start Here",
      // desc: "The newest luxury wellness spa experience in Yangon for your inner peace and outer beauty.",
      // img: banner2,
    },
    {
      id: 6,
      title: "FAQ",
      img: logo,
      // title_span: "start Here",
      // desc: "The newest luxury wellness spa experience in Yangon for your inner peace and outer beauty.",
      // img: banner2,
    },
  ];
  const categoryData = [
    {
      id: 1,
      img: img1,
      title: "Skin Care",
    },
    {
      id: 2,
      img: img2,
      title: " sun cream",
    },
    {
      id: 3,
      img: img3,
      title: "Eye Shadow",
    },
    {
      id: 4,
      img: img4,
      title: "eye liner",
    },
    {
      id: 5,
      img: img5,
      title: "Scented Candle",
    },
    {
      id: 6,
      img: img6,
      title: "Shampoo",
    },
  ];
  return (
    <div className="overflow-x-hidden">
      <Header />
      <HeroSection />
      <BestSellerAndNewarrivel />
      <CategorySlide SlideData={aboutData} />
      <Prevent />
      {/* <CardSlide SlideData={CardSlideData} /> */}
      {/* <JoinDay /> */}
      {/* <Elevate
        SlideData={ElevateData}
        title={" Brands To Elevate Your Routine"}
      /> */}
      {/* <Ingredient /> */}
      {/* <Loved /> */}
      {/* <ShopByCat /> */}
      <CategorySlide SlideData={categoryData} />
      <FeateureBrad />
      {/* <Place /> */}
      <Footer />
    </div>
  );
};

export default HomePage;
